import { mutationOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["staffApiSms"] as QueryKey,
};
export const staffApiSms = {
  keys: keys,
  queries: {},
  mutations: {
    sendSMSToMember: () =>
      mutationOptions({
        mutationFn: async ({
          body,
          userId,
        }: {
          body: string;
          userId: string;
        }) => {
          return (await api.post(`/user-member-send-sms/${userId}`, { body }))
            .data;
        },
      }),
  },
};
